import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';


export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(8px);
  padding: 48px;
  width: 100%;
  gap: 2rem;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 2rem;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.32px;

  ${mediaQuery.maxWidth.tablet} {
    font-size: 1.25rem;
  }
`;

export const Description = styled.div<{ expanded: boolean }>`
  color: ${({ theme }) => theme.colors.white75};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  overflow: hidden;
  transition: max-height 0.3s ease;

  ${props =>
    !props.expanded &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  `}
`;

export const ButtonLink = styled.div`
  display: flex;
  padding: 16px 56px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 800px;
  background: rgba(255, 255, 255, 0.10);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fontFamily.bold};
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 700;
  letter-spacing: -0.32px;
`;

export const IconImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
`;